import { useEffect, useState } from "react";
import { api } from "./api";

let cache = null;
const listeners = new Set();

const load = () => api.get("/prices").then((r) => { cache = r.data; listeners.forEach((fn) => fn(cache)); }).catch(() => {});

export function usePrices() {
  const [data, setData] = useState(cache);
  useEffect(() => {
    listeners.add(setData);
    if (!cache) load();
    const t = setInterval(load, 60000);
    return () => { listeners.delete(setData); clearInterval(t); };
  }, []);
  return data;
}

export const usdValue = (prices, currency, amount) => (prices?.prices?.[currency]?.usd || 0) * (amount || 0);
export const usdTotal = (prices, balances = {}) => Object.entries(balances).reduce((s, [c, v]) => s + usdValue(prices, c, v), 0);
